var exports = {
  "o": "x61f99309--99ed56--actions",
};

module.exports = exports;
